const routes = [
  {
    path: '/events',
    component: () => import("@/_routes/events/_index"),
  },
]

export default routes
